import { render } from "./DataChat.vue?vue&type=template&id=3491ba01&scoped=true"
import script from "./DataChat.vue?vue&type=script&lang=js"
export * from "./DataChat.vue?vue&type=script&lang=js"

import "./DataChat.vue?vue&type=style&index=0&id=3491ba01&scoped=true&lang=css"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3491ba01"]])

export default __exports__